import React, { useState, useEffect, useRef } from 'react';

import { Box, Typography, Collapse } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import IconButton from '@components/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import AppBreadcrumbs from '../app-breadcrumbs';
import { useIsScrolling } from '../scroll-context';

const UtilityHeader = ({
  title,
  children,
  hideBreadcrumbs,
  onBackClicked,
  UtilityBar,
  select,
  disableCollapseChildren
}) => {
  const theme = useTheme();
  const trigger = useIsScrolling();
  const [expanded, setExpanded] = useState(true);
  const [userInitiated, setUserInitiated] = useState(false);
  const timerRef = useRef(true);

  useEffect(() => {
    if (userInitiated) return;

    if (timerRef.current === true) {
      setExpanded(!trigger);
    }
  }, [trigger]);

  useEffect(() => {
    timerRef.current = false;

    setTimeout(() => {
      timerRef.current = true;
    }, 250);
  }, [expanded]);

  const handleManualExpand = () => {
    setUserInitiated(true);
    setExpanded(!expanded);
  };

  return (
    <Collapse
      collapsedSize={48}
      in={expanded || disableCollapseChildren}
      timeout="auto"
      sx={{
        boxShadow: !trigger ? 0 : 4,
        zIndex: theme.zIndex.appBar,
        displayPrint: 'none',
        backgroundColor: 'appBackground.main'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={[{ py: 1, px: 2, overflow: 'hidden' }]}>
          {!hideBreadcrumbs && (
            <Box
              sx={{
                transition: theme.transitions.create('height'),
                overflow: 'hidden',
                height: expanded ? '20px' : '0px'
              }}
            >
              {!hideBreadcrumbs && <AppBreadcrumbs />}
            </Box>
          )}

          <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
            {onBackClicked && (
              <IconButton
                onClick={onBackClicked}
                size="small"
                sx={{ mr: 1, transform: 'translateY(4px)' }}
                aria-label="navigate back"
              >
                <ArrowBackIosNewIcon />
              </IconButton>
            )}

            <Typography
              variant="pageTitle"
              sx={{
                mt: expanded ? 0.5 : 0,
                transition: theme.transitions.create('font-size'),
                fontSize: expanded ? theme.typography.pageTitle.fontSize : '1.1rem'
              }}
              noWrap
            >
              {title}
            </Typography>

            {expanded && select}
          </Box>
        </Box>
        <Box sx={{ flex: 1 }} />

        <IconButton onClick={handleManualExpand} tabIndex={-1} aria-label="expand">
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>

        <UtilityBar />
      </Box>
      {children}
    </Collapse>
  );
};

export default UtilityHeader;
